export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "Website",
    introCreated:
      "Ihre Website ist bereits erstellt. Gehen Sie rein und bearbeiten Sie sie, wann immer Sie möchten.",
    introEmpty:
      "Erstellen Sie die Website Ihrer Unterkunft, mit eingebautem Kalender. Sie bearbeiten sie per Drag-and-drop, ganz ohne Programmieren.",
    emptyTitle: "Sie haben noch keine Website",
    emptyBody:
      "Sie wählen eine Vorlage für Ihre Branche, tauschen Fotos und Texte aus und haben eine Website, die Sie veröffentlichen können. Die Datumssuche bleibt mit Ihrem Kalender verbunden.",
    creating: "Wird erstellt…",
    createCta: "Meine Website erstellen",
    createAnother: "Weitere Website erstellen",
    collapse: "Einklappen",
    expand: "Details ansehen",
    limitReached: "Ihr Plan erlaubt {n} Website(s).",
    lockedTitle: "Ihre Website gehört zum Suite-Plan",
    lockedBody:
      "Um die Website Ihrer Unterkunft mit WACheckin zu erstellen und zu verwalten, brauchen Sie einen aktiven Suite-Plan.",
    lockedCta: "Suite-Plan ansehen",
    nameLabel: "Name Ihrer Website",
    viewWeb: "Website ansehen",
    opening: "Wird geöffnet…",
    editCta: "Meine Seite bearbeiten",
    noPublicAddress: "Sie hat noch keine öffentliche Adresse",
    published: "Veröffentlicht",
    unpublished: "Nicht veröffentlicht",
    visibleToPublic: "Öffentlich sichtbar",
    addressTitle: "Adresse Ihrer Website",
    addressSubtitle: "Wählen Sie, unter welcher Adresse Ihre Gäste sie sehen sollen.",
    modeWacheckin: "Eine WACheckin-Adresse verwenden",
    modeWacheckinHint: "Kostenlos und sofort einsatzbereit",
    modeOwn: "Eigene Domain verwenden",
    modeOwnHint: "Falls Sie schon eine haben",
    subdomainLabel: "Das Wort, das vorne steht",
    subdomainPlaceholder: "name-meiner-unterkunft",
    saving: "Wird gespeichert…",
    save: "Speichern",
    subdomainPreview: "Ihre Website liegt dann unter",
    subdomainFree:
      "Schreiben Sie es, wie Sie möchten: Wir machen daraus eine gültige Adresse.",
    otherDomainNote:
      "Sie haben außerdem {dominio} verbunden. Diese Adresse funktioniert weiterhin und führt zur selben Website.",
    noDomainYet: "Sie haben noch nicht angegeben, welche Domain Sie möchten",
    continueConnection: "Verbindung fortsetzen",
    connectDomain: "Meine Domain verbinden",
    searchTitle: "Welche Unterkünfte die Suche anzeigen darf",
    searchSubtitle:
      "Die hier angehakten sehen Ihre Gäste, wenn sie nach Daten suchen.",
    missingPhotosLabel: "Noch keine Fotos:",
    missingPhotosHelp:
      "Laden Sie sie unter Direktbuchungen → Bilder hoch, dann erscheinen sie hier. Sie müssen nicht im Verkauf sein.",
    previewError: "Die Vorschau konnte nicht geladen werden.",
    previewRetry: "Erneut versuchen",
    deleteExplain: "Löscht die Website und alles darin. Das lässt sich nicht rückgängig machen.",
    deleteTitle: "„{nombre}“ löschen?",
    deleteBody: "Das lässt sich nicht rückgängig machen. Wenn Sie sie nur verbergen möchten, schalten Sie „Öffentlich sichtbar“ aus und die Website bleibt gespeichert.",
    deleteItemPages: "Ihre {n} Seiten, mit ihren Texten und ihrem Design",
    deleteItemAddress: "Die Adresse, unter der sie erreichbar ist",
    deleteItemMessages: "Die Nachrichten, die Sie über ihre Formulare erhalten haben",
    deleteCancel: "Abbrechen",
    deleteConfirm: "Ja, löschen",
    deleting: "Wird gelöscht…",
    previewTitle: "Ihre Website gerade jetzt",
    previewDesktop: "Desktop",
    previewMobile: "Mobil",
    previewLoading: "Ihre Website wird geladen…",
    previewNote: "So sieht sie mit Ihren zuletzt gespeicherten Änderungen aus. Gäste sehen das, was Sie zuletzt veröffentlicht haben.",
    footerNote:
      "Vorerst hat jedes Konto eine Website. Schreiben Sie uns, wenn Sie mehr brauchen.",
    deleteWeb: "Diese Website löschen",
    mensajes: {
      title: "Nachrichten von Ihrer Website",
      subtitle: "Was Leute in die Formulare Ihrer Website schreiben. Jede Nachricht erreicht Sie auch per E-Mail.",
      inbox: "Posteingang",
      archived: "Archiviert",
      unread: "{n} ungelesen",
      empty: "Noch hat niemand geschrieben. Wenn jemand ein Formular auf Ihrer Website ausfüllt, sehen Sie es hier und bekommen es per E-Mail.",
      emptyArchived: "Sie haben keine archivierten Nachrichten.",
      loadError: "Die Nachrichten konnten nicht geladen werden.",
      retry: "Erneut versuchen",
      reply: "Per E-Mail antworten",
      whatsapp: "WhatsApp",
      call: "Anrufen",
      markRead: "Als gelesen markieren",
      markUnread: "Als ungelesen markieren",
      archive: "Archivieren",
      unarchive: "In den Posteingang verschieben",
      delete: "Löschen",
      confirmDelete: "Diese Nachricht löschen? Das lässt sich nicht rückgängig machen.",
      confirmYes: "Ja, löschen",
      confirmNo: "Nein",
      form: "Formular",
      from: "Von",
      more: "Mehr laden",
      anonymous: "Ohne Namen",
      replySubject: "Ihre Nachricht auf {sitio}",
      notSent: "Die E-Mail-Benachrichtigung ist noch nicht raus.",
      errorAction: "Die Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.",
    },
    loadingAccommodations: "Ihre Unterkünfte werden geladen…",
    noPhotosYet:
      "Noch hat keine Ihrer Unterkünfte Fotos. Laden Sie sie unter Direktbuchungen → Bilder hoch, dann können Sie sie hier zeigen.",
    noAccommodations: "Sie haben noch keine Unterkünfte angelegt.",
    loadError: "Ihre Seiten konnten nicht geladen werden.",
    defaultSiteName: "Meine Unterkunft",
    createError: "Die Seite konnte nicht erstellt werden.",
    saveError: "Es konnte nicht gespeichert werden.",
    subdomainTooLong: "Das ist zu lang geworden.",
    subdomainReserved: "Dieses Wort ist reserviert. Versuchen Sie ein anderes.",
    addressSaved: "Adresse gespeichert.",
    subdomainChecking: "Es wird geprüft, ob sie frei ist…",
    subdomainAvailable: "Sie ist frei. Ihre Website liegt dann unter",
    subdomainChangeWarning: "Sobald Sie speichern, funktioniert Ihre aktuelle Adresse nicht mehr.",
    subdomainTaken: "Diese Adresse wird bereits von einer anderen Website genutzt.",
    subdomainTryThis: "Diese ist frei:",
    subdomainUse: "Diese verwenden",
    subdomainGeneric: "Sie sagt nichts über Ihre Unterkunft aus. Unser Vorschlag:",
    subdomainProposal: "Wir schlagen eine mit dem Namen Ihrer Unterkunft vor:",
    domainHelpEmpty:
      "Wir führen Sie Schritt für Schritt: Sie geben die Domain ein, kopieren zwei Zeilen in das Panel, wo Sie sie gekauft haben, und wir prüfen es für Sie.",
    domainHelpPending:
      "Im Panel Ihrer Domain fehlen die Einträge, oder sie sind noch nicht überall angekommen. Gehen Sie rein und wir prüfen es.",
    popupBlocked: "Erlauben Sie Pop-ups, um den Editor zu öffnen.",
    editorError: "Der Editor konnte nicht geöffnet werden.",
    confirmDelete: `"{nombre}" löschen? Die Website wird dann nicht mehr angezeigt.`,
    deleteError: "Es konnte nicht gelöscht werden.",
  },

  selectOta: {
    lockBadge: "Funktion im Abonnement",
    lockTitle: "Verbinden Sie Ihre OTAs mit einem aktiven Plan",
    lockText:
      "Um <b>Booking, Airbnb, Vrbo, Expedia</b> und weitere Kanäle mit WA&nbsp;Checkin zu synchronisieren, brauchen Sie ein Abonnement. Mit Ihrem Abonnement synchronisiert Janet Preise, Verfügbarkeit und Buchungen automatisch: kein Overbooking und keine Handarbeit.",
    morePreviewTitle: "und mehr als 100 OTAs",
    otasAvailable: "OTAs verfügbar",
    lockCta: "Pläne ansehen und abonnieren",
    lockFoot:
      "Automatische Synchronisierung · Schutz vor Overbooking · Hilfe beim Verbinden inklusive",
    connectOtaTitle: "OTA verbinden",
    googleFaltan: "Ihrem Inserat fehlt 1 Angabe für Google | Ihrem Inserat fehlen {count} Angaben für Google",
    googlePreparar: "Vorbereiten",
    beta: "Beta",
    pctChipTitle: "Prozentsatz des abgeleiteten Tarifs für diese OTA",
    comingSoon: "Demnächst",
    manage: "Verwalten",
    connectNow: "Jetzt verbinden",
    pctModalTitle: "Tarif-Prozentsatz",
    pctModalHint:
      "Wie viel Prozent mehr (oder weniger) berechnen Sie Ihren Gästen, wenn sie über <b>{ota}</b> buchen? Mit <b>+</b> berechnen Sie mehr, mit <b>−</b> weniger (z. B.: <b>15.5</b> oder <b>−10</b>).",
    thisOta: "diese OTA",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Speichern",
    exploreMore: "Mehr als 100 verfügbare OTAs entdecken",
    activeConnections: "Aktive Verbindungen",
    searchPlaceholder: "Suchen...",
    loadingConnections: "Verbindungen werden geladen...",
    thChannel: "KANAL",
    thConnectionId: "VERBINDUNGS-ID",
    thLastSync: "LETZTE SYNC.",
    thActions: "AKTIONEN",
    copied: "Kopiert!",
    copyId: "ID kopieren",
    contactTitle: "Mit {name} verbinden",
    contactDescription:
      "Verbinden Sie Ihr {name}-Konto ganz einfach mit unserer Plattform, damit alles schneller läuft. Folgen Sie den Schritten unten, um den Vorgang abzuschließen.",
    step1Title: "Ein {name}-Konto erstellen",
    step1Description:
      "Wenn Sie noch kein {name}-Konto haben, müssen Sie zuerst eines erstellen.",
    createAccountLink: "Konto erstellen →",
    step1Hint: "Sie haben schon ein Konto? Weiter zu Schritt 2.",
    step2Title: "Das Support-Team kontaktieren",
    step2Description:
      "Sobald Ihr {name}-Konto bereit ist, hilft Ihnen unser Team beim Verbinden.",
    contactSupportLink: "Support-Team kontaktieren →",
    connectDirectNoSupport: "Direkt verbinden (ohne Support) →",
    step2Hint: "Nur empfohlen, wenn Sie wissen, was Sie in Channex einrichten werden.",
    connectDirectly: "Direkt verbinden",
    iframeTitle: "Mit {channel} verbinden",
    iframeSubtitle: "Sichere Verbindung, verwaltet vom channel manager",
    close: "Schließen",
    iframeLoading: "Die sichere Verbindung wird geöffnet…",
    actionRequired: "Aktion erforderlich",
    viewPlans: "Pläne ansehen",
    descBooking: "Erreichen Sie Geschäfts- und Urlaubsreisende auf der ganzen Welt",
    descAirbnb: "Verbinden Sie Ihre Unterkunft mit Millionen von Reisenden auf Airbnb",
    descVrbo: "Spezialisiert auf Ferienunterkünfte für Familien",
    descExpedia: "Globales Reisenetzwerk mit Millionen aktiver Nutzer",
    descBnb: "Italienisches Portal für B&Bs und Unterkünfte mit Charme",
    descGvr: "Erscheinen Sie kostenlos in Google Maps und in den Suchergebnissen",
    descAgoda: "Erreichen Sie Reisende aus Asien und dem Rest der Welt",
    descHotelbeds: "Betten für Reisebüros und Reiseveranstalter weltweit",
    savePercentError: "Der Prozentsatz konnte nicht gespeichert werden. Bitte erneut versuchen.",
    channelGeneric: "Kanal",
    statusInactive: "Inaktiv",
    statusConnected: "Verbunden",
    statusSyncing: "Wird synchronisiert",
    webReservationsName: "Direktbuchungen über die Website",
  },

  connectionChannel: {
    errorTitle: "Fehler",
    successTitle: "Geschafft",
    connectionDisabled: "Die Verbindung ist deaktiviert",
    syncError: "Fehler beim Synchronisieren",
    loadPropertiesError: "Fehler beim Laden der Unterkünfte",
    connectionUpdated: "Verbindung aktualisiert {channelName}",
    updateConnError: "Fehler beim Aktualisieren der Verbindung: {detail}",
    unknownError: "Unbekannter Fehler",
    connectionWith: "Verbindung mit {channelName} {status}",
    stateUpdatedTitle: "Status aktualisiert",
    confirmDeleteMessage:
      "Möchten Sie diese Verbindung wirklich löschen? Dabei werden auch die zugehörigen Unterkünfte und Buchungen gelöscht.",
    confirmDeleteHeader: "Löschen bestätigen",
    deleteConnection: "Verbindung löschen",
    no: "Nein",
    connectionDeleted: "Verbindung erfolgreich gelöscht",
    deleteConnError: "Fehler beim Löschen der Verbindung: {detail}",
    webhookCopied: "Webhook in die Zwischenablage kopiert",
    webhookCopyError: "Fehler beim Kopieren des Webhooks",
    title: "Verbindungskanal (PMS)",
    description:
      "In diesem Bereich können Sie sich mit Property-Management-Systemen (PMS) verbinden, um Informationen effizient und fehlerfrei abzufragen, zu verwalten und zu aktualisieren.",
    connectedAccount: "Verbundenes Konto",
    switchTooltip:
      "Den Dienst stoppen oder starten, der Buchungen automatisch ins System übernimmt.",
    syncing: "Wird synchronisiert...",
    sync: "Synchronisieren",
    deleting: "Wird gelöscht...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "Fügen Sie diesen Webhook zu Ihrem Smoobu-Konto hinzu, um die in Ihrem PMS erstellten Buchungen automatisch zu erhalten",
    copyToClipboard: "In die Zwischenablage kopieren",
    syncedProperties: "Synchronisierte Unterkünfte",
    noAddress: "Keine Adresse",
    noSyncedProperties: "Es gibt keine synchronisierten Unterkünfte",
  },

  wabaIntegration: {
    activationInProgress: "Aktivierung läuft",
    pendingBody:
      "Wir aktivieren gerade Ihr geschäftliches WhatsApp. Während Meta Ihre Vorlagen freigibt (das dauert meist bis zu 24&nbsp;h) und Ihre Nummer prüft, werden Ihre Nachrichten über das <strong>WhatsApp von WACheckin</strong> gesendet, damit die Kommunikation mit Ihren Gästen nicht abreißt. Sobald alles bereit ist, wird <strong>automatisch</strong> auf Ihre eigene Nummer umgestellt, Sie müssen nichts tun.",
    phoneStatusHeading: "Status der WhatsApp-Nummer",
    numberLabel: "Nummer:",
    virtualNumberNote:
      "Das ist eine <strong>von Meta bereitgestellte virtuelle Nummer</strong>. Sie empfängt keine normalen Anrufe und keine SMS, nur WhatsApp-Nachrichten über die API.",
    statusLabel: "Status:",
    templatesStatusHeading: "Status der Vorlagen",
    canSend:
      "Ihre Nummer ist <strong>verbunden und verifiziert</strong> und Sie haben mindestens eine freigegebene Vorlage. Sie können jetzt Nachrichten senden.",
    cannotSendYet:
      "Sie <strong>können noch keine Nachrichten senden</strong>. Warten Sie, bis Meta die Rufnummer und die Vorlagen freigegeben hat.",
    virtualPendingNote:
      "Beachten Sie: Wenn Ihr Unternehmen bei Meta nicht verifiziert ist, können virtuelle Nummern im Status <strong>ausstehend</strong> bleiben und den Versand nicht zulassen.",
    statusConnectedVerified: "Verbunden und verifiziert",
    statusConnectedPending: "Verbunden, Verifizierung ausstehend",
    statusPendingApproval: "Freigabe ausstehend",
    statusDisconnected: "Getrennt",
    statusUnknown: "Unbekannt",
  },
};
